var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "benchmarking-table",
    },
    [
      _c("table-header", {
        attrs: {
          "page-size": _vm.tableExtraFilters.pageSize,
        },
        on: {
          "page-size-changed": _vm.onPageSizeChanged,
          "search-triggered": _vm.onTriggerSearch,
          "clear-search-term": _vm.onClearSearchTerm,
        },
      }),
      _c("ag-grid-vue", {
        staticClass: "ag-theme-alpine",
        attrs: {
          "grid-options": _vm.gridOptions,
        },
        on: {
          "grid-ready": _vm.onGridReady,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }